import { Component, NgZone, OnInit } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorTextualConfig } from '@core/interfaces/modal-error-config.interface';
import { AccUrl, ftdUrl, UnHappyPathModal } from '@core/layouts/default/default.config';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { BRIDGER_INSIGHT_CONFIG } from './bridger-insight.component.config';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'shell-bridger-insight',
  templateUrl: './bridger-insight.component.html',
})
export class BridgerInsightComponent implements OnInit {
  config: ModalErrorTextualConfig;
  modalError: any;

  constructor(
    private modalService: ModalService,
    private microFrontendRouter: MicroFrontendRouter,
    public messageBusService: MessageBusService,
    public ngZone: NgZone,
  ) {}

  closeModal(): void {
    const modalError: any = this.messageBusService.getValue('shell', 'modal.error') || {
      gtm: '',
      savingAccountName: '',
    };

    if (modalError.gtm === UnHappyPathModal.NO_CONFIRM_MODAL) {
      this.messageBusService.emit('shell', 'google-tag-manager.event', {
        event: 'button-event',
        eventCategory: 'Complementos',
        eventAction: 'No cumplo los requisitos',
        eventLabel: `Entendido - ${modalError.savingAccountName}`,
      });
    }
    switch (this.modalError?.project) {
      case PROJECTS.ACC:
        window.location.href = window.location.origin + AccUrl.preferentialUsd;
        break;
      case PROJECTS.PLD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.FTD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        window.location.href = window.location.origin + ftdUrl.firstPage;
        break;
    }
    this.modalService.close();
    window.location.reload();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBusService.getValue('shell', 'modal.error');
        this.config = BRIDGER_INSIGHT_CONFIG.get(
          this.modalError?.project,
        ) as ModalErrorTextualConfig;
      });
    }, 50);

    /**/
  }
}
